// Word packs for charades game
// Restructured: Two categories per language - All Ages and 18+ Mature
// All expressions are 2 words or less

export const wordPacks = {
  // ============================================
  // ENGLISH
  // ============================================
  en_allAges: {
    id: 'en_allAges',
    name: 'All Ages Charades',
    description: 'Fun charades for everyone',
    language: 'en',
    isPremium: false,
    words: [
      // Existing 2-word expressions
      'Kangaroo Boxing',
      'Elephant Tiptoeing',
      'Monkey Typing',
      'Uncontrollable Hiccups',
      'Autocorrect Fail',
      'Clumsy Surgeon',
      'Underwater Firefighter',
      'Robot Therapist',
      'Ninja Librarian',
      'Breakdancing Lawyer',
      'Skydiving Teacher',
      'Singing Dentist',
      'Extreme Ironing',
      'Competitive Napping',
      'Professional Procrastinator',
      'Synchronized Swimming',
      'Backwards Running',
      // New expressions
      'Panic sneeze',
      'Invisible leash',
      'Hot toes',
      'Slow panic',
      'Sudden cramp',
      'Awkward dancing',
      'Falling confidence',
      'Fake confidence',
      'Reverse moonwalk',
      'Stuck spinning',
      'Overheated penguin',
      'Fear sweating',
      'Dramatic stumble',
      'Lost balance',
      'Emergency wiggle',
      'Silent screaming',
      'Confused ninja',
      'Melting robot',
      'Slippery victory',
      'Delayed reaction',
      'Nervous shaking',
      'Unstable superhero',
      'Dizzy boxing',
      'Wobbly stubbornness',
      'Failing magician',
      'Sneaky panic',
      'Reverse sprint',
      'Icy socks',
      'Sudden courage',
      'Unwanted applause',
      'Confident slipping',
      'Trapped dancing',
      'Falling bravely',
      'Delayed flinch',
      'Overacting horror',
      'Hesitation shuffle',
      'Power tripping',
      'Dramatic balance',
      'Sudden invisibility',
      'Forgotten footing',
      'Nervous statue',
      'Backward confidence',
      'Glitch walking',
      'Overheated sneaking',
      'Panic floating',
      'Slippery betrayal',
      'Failing stealth',
      'Confused victory',
      'Sudden disguise',
      'Stuck swagger',
      'Nervous flexing',
      'Wobble fighting',
      'Icy panic',
      'Fake injury',
      'Overconfident slipping',
      'Sneezing attack',
      'Trapped shadow',
      'Broken rhythm',
      'Awkward victory',
      'Dramatic hesitation',
      'Backward sneaking',
      'Sudden gravity',
      'Nervous clapping',
      'Unstable disguise',
      'Failing confidence',
      'Clumsy triumph',
      'Melting bravery',
      'Delayed victory',
      'Slippery dodge',
      'Unexpected balance',
      'Glitch dancing',
      'Trapped excitement',
      'Sudden fear',
      'Wobbly intimidation',
      'Overacting confidence',
      'Glitched sprint',
      'Accidental toughness',
      'Failing swagger',
      'Retreating victory',
      'Fake toughness',
      'Nervous hero',
      'Wobbling escape',
      'Sudden flexibility',
      'Failing elegance',
      'Tripping victory',
      'Confident wobble',
      'Sneaky slipping',
      'Dancing panic',
      'Delayed dodge',
      'Panicked sneaking',
      'Frozen celebration',
      'Shaky confidence',
      'Slippery rescue',
      'Overconfident retreat',
      'Nervous charging',
      'Dramatic retreat',
      'Glitch dodging',
      'Sudden stiffness',
      'Wobbly courage',
      'Accidental victory'
    ]
  },

  en_mature: {
    id: 'en_mature',
    name: '18+ Mature Charades',
    description: 'For adult parties only!',
    language: 'en',
    isPremium: false,
    words: [
      // Existing 2-word expressions
      'Walk of shame',
      'Fake Orgasm',
      'Hangover Regret',
      // New expressions
      'Bedroom panic',
      'Speed flirting',
      'Drunk confidence',
      'Bathroom regret',
      'Flirty sneezing',
      'Accidental twerking',
      'Wardrobe malfunction',
      'Rejected proposal',
      'Panic stripping',
      'Flirty tripping',
      'Desperate posing',
      'Overconfident seduction',
      'Sudden modesty',
      'Mirror flirting',
      'Jealous sneaking',
      'Silent moaning',
      'Desperate dancing',
      'Flirty panic',
      'Late walk',
      'Tipsy swagger',
      'Sudden exposure',
      'Accidental flashing',
      'Awkward cuddling',
      'Drunk texting',
      'Rebound flirting',
      'Risky stretching',
      'Desperate flexing',
      'Strip stumble',
      'Morning regret',
      'Panic covering',
      'Flirty escaping',
      'Accidental touching',
      'Awkward positioning',
      'Overheated cuddling',
      'Shy grinding',
      'Sudden rejection',
      'Bold retreat',
      'Desperate whispering',
      'Flirty sneaking',
      'Panic kissing',
      'Accidental lap-sit',
      'Tense cuddling',
      'Drunk whispering',
      'Risky dancing',
      'Sudden seduction',
      'Awkward teasing',
      'Flirty freezing',
      'Panic hugging',
      'Embarrassed exiting',
      'Overconfident stripping',
      'Desperate flirting',
      'Accidental seduction',
      'Tense spooning',
      'Flirty bumping',
      'Sudden intimacy',
      'Nervous stripping',
      'Panic cuddling',
      'Flirty chasing',
      'Jealous dancing',
      'Accidental grinding',
      'Tense flirting',
      'Sudden passion',
      'Overheated flirting',
      'Bold teasing',
      'Panic retreat',
      'Shy seduction',
      'Risky cuddling',
      'Embarrassed flirting',
      'Sudden spooning',
      'Tense touching',
      'Desperate seduction',
      'Flirty hesitation',
      'Panic positioning',
      'Awkward passion',
      'Shy flirting',
      'Overconfident cuddling',
      'Risky whispering',
      'Jealous seduction',
      'Accidental intimacy',
      'Sudden embarrassment',
      'Flirty awkwardness',
      'Desperate grinding',
      'Panic seduction',
      'Bold cuddling',
      'Tense chasing',
      'Embarrassed retreat',
      'Flirty confusion',
      'Drunk flirting',
      'Panic intimacy',
      'Awkward seduction',
      'Sudden shyness',
      'Bold positioning',
      'Nervous cuddling',
      'Risky flirting',
      'Panic teasing',
      'Accidental romance'
    ]
  },

  // ============================================
  // ALBANIAN (sq)
  // ============================================
  sq_allAges: {
    id: 'sq_allAges',
    name: 'Shqip - Për të gjithë',
    description: 'Sharada argëtuese për të gjithë',
    language: 'sq',
    isPremium: false,
    words: [
      // New expressions
      'vallëzim nervoz',
      'ecje nervoz',
      'pinguin nervoz',
      'robot nervoz',
      'ninxha nervoz',
      'pulë nervoz',
      'octapod nervoz',
      'teshtimë nervoz',
      'arratisje nervoz',
      'paradë nervoz',
      'vallëzim i ngathët',
      'ecje i ngathët',
      'pinguin i ngathët',
      'robot i ngathët',
      'ninxha i ngathët',
      'pulë i ngathët',
      'octapod i ngathët',
      'teshtimë i ngathët',
      'arratisje i ngathët',
      'paradë i ngathët',
      'vallëzim panik',
      'ecje panik',
      'pinguin panik',
      'robot panik',
      'ninxha panik',
      'pulë panik',
      'octapod panik',
      'teshtimë panik',
      'arratisje panik',
      'paradë panik',
      'vallëzim i lëkundur',
      'ecje i lëkundur',
      'pinguin i lëkundur',
      'robot i lëkundur',
      'ninxha i lëkundur',
      'pulë i lëkundur',
      'octapod i lëkundur',
      'teshtimë i lëkundur',
      'arratisje i lëkundur',
      'paradë i lëkundur',
      'vallëzim i përgjumur',
      'ecje i përgjumur',
      'pinguin i përgjumur',
      'robot i përgjumur',
      'ninxha i përgjumur',
      'pulë i përgjumur',
      'octapod i përgjumur',
      'teshtimë i përgjumur',
      'arratisje i përgjumur',
      'paradë i përgjumur',
      'vallëzim energjik',
      'ecje energjik',
      'pinguin energjik',
      'robot energjik',
      'ninxha energjik',
      'pulë energjik',
      'octapod energjik',
      'teshtimë energjik',
      'arratisje energjik',
      'paradë energjik',
      'vallëzim i fshehtë',
      'ecje i fshehtë',
      'pinguin i fshehtë',
      'robot i fshehtë',
      'ninxha i fshehtë',
      'pulë i fshehtë',
      'octapod i fshehtë',
      'teshtimë i fshehtë',
      'arratisje i fshehtë',
      'paradë i fshehtë',
      'vallëzim i ngrirë',
      'ecje i ngrirë',
      'pinguin i ngrirë',
      'robot i ngrirë',
      'ninxha i ngrirë',
      'pulë i ngrirë',
      'octapod i ngrirë',
      'teshtimë i ngrirë',
      'arratisje i ngrirë',
      'paradë i ngrirë',
      'vallëzim i sikletshëm',
      'ecje i sikletshëm',
      'pinguin i sikletshëm',
      'robot i sikletshëm',
      'ninxha i sikletshëm',
      'pulë i sikletshëm',
      'octapod i sikletshëm',
      'teshtimë i sikletshëm',
      'arratisje i sikletshëm',
      'paradë i sikletshëm',
      'vallëzim dramatik',
      'ecje dramatik',
      'pinguin dramatik',
      'robot dramatik',
      'ninxha dramatik',
      'pulë dramatik',
      'octapod dramatik',
      'teshtimë dramatik',
      'arratisje dramatik',
      'paradë dramatik'
    ]
  },

  sq_mature: {
    id: 'sq_mature',
    name: 'Shqip - 18+ Vetëm për të rritur',
    description: 'Vetëm për festa të të rriturve!',
    language: 'sq',
    isPremium: false,
    words: [
      'flirt i sikletshëm',
      'përqafim i sikletshëm',
      'pëshpëritje i sikletshëm',
      'shikim i sikletshëm',
      'përkëdhelje i sikletshëm',
      'puthje i sikletshëm',
      'afrim i sikletshëm',
      'tërheqje i sikletshëm',
      'vallëzim i sikletshëm',
      'moment i sikletshëm',
      'flirt flirtues',
      'përqafim flirtues',
      'pëshpëritje flirtues',
      'shikim flirtues',
      'përkëdhelje flirtues',
      'puthje flirtues',
      'afrim flirtues',
      'tërheqje flirtues',
      'vallëzim flirtues',
      'moment flirtues',
      'flirt i ndrojtur',
      'përqafim i ndrojtur',
      'pëshpëritje i ndrojtur',
      'shikim i ndrojtur',
      'përkëdhelje i ndrojtur',
      'puthje i ndrojtur',
      'afrim i ndrojtur',
      'tërheqje i ndrojtur',
      'vallëzim i ndrojtur',
      'moment i ndrojtur',
      'flirt i dehur',
      'përqafim i dehur',
      'pëshpëritje i dehur',
      'shikim i dehur',
      'përkëdhelje i dehur',
      'puthje i dehur',
      'afrim i dehur',
      'tërheqje i dehur',
      'vallëzim i dehur',
      'moment i dehur',
      'flirt xheloz',
      'përqafim xheloz',
      'pëshpëritje xheloz',
      'shikim xheloz',
      'përkëdhelje xheloz',
      'puthje xheloz',
      'afrim xheloz',
      'tërheqje xheloz',
      'vallëzim xheloz',
      'moment xheloz',
      'flirt i guximshëm',
      'përqafim i guximshëm',
      'pëshpëritje i guximshëm',
      'shikim i guximshëm',
      'përkëdhelje i guximshëm',
      'puthje i guximshëm',
      'afrim i guximshëm',
      'tërheqje i guximshëm',
      'vallëzim i guximshëm',
      'moment i guximshëm',
      'flirt nervoz',
      'përqafim nervoz',
      'pëshpëritje nervoz',
      'shikim nervoz',
      'përkëdhelje nervoz',
      'puthje nervoz',
      'afrim nervoz',
      'tërheqje nervoz',
      'vallëzim nervoz',
      'moment nervoz',
      'flirt i tensionuar',
      'përqafim i tensionuar',
      'pëshpëritje i tensionuar',
      'shikim i tensionuar',
      'përkëdhelje i tensionuar',
      'puthje i tensionuar',
      'afrim i tensionuar',
      'tërheqje i tensionuar',
      'vallëzim i tensionuar',
      'moment i tensionuar',
      'flirt i turpëruar',
      'përqafim i turpëruar',
      'pëshpëritje i turpëruar',
      'shikim i turpëruar',
      'përkëdhelje i turpëruar',
      'puthje i turpëruar',
      'afrim i turpëruar',
      'tërheqje i turpëruar',
      'vallëzim i turpëruar',
      'moment i turpëruar',
      'flirt i fshehtë',
      'përqafim i fshehtë',
      'pëshpëritje i fshehtë',
      'shikim i fshehtë',
      'përkëdhelje i fshehtë',
      'puthje i fshehtë',
      'afrim i fshehtë',
      'tërheqje i fshehtë',
      'vallëzim i fshehtë',
      'moment i fshehtë'
    ]
  },

  // ============================================
  // CHINESE (zh)
  // ============================================
  zh_allAges: {
    id: 'zh_allAges',
    name: '中文 - 全年龄',
    description: '适合所有人的有趣猜词',
    language: 'zh',
    isPremium: false,
    words: [
      '慌张 舞蹈',
      '慌张 走路',
      '慌张 企鹅',
      '慌张 机器人',
      '慌张 忍者',
      '慌张 小鸡',
      '慌张 章鱼',
      '慌张 喷嚏',
      '慌张 逃跑',
      '慌张 游行',
      '笨拙 舞蹈',
      '笨拙 走路',
      '笨拙 企鹅',
      '笨拙 机器人',
      '笨拙 忍者',
      '笨拙 小鸡',
      '笨拙 章鱼',
      '笨拙 喷嚏',
      '笨拙 逃跑',
      '笨拙 游行',
      '紧张 舞蹈',
      '紧张 走路',
      '紧张 企鹅',
      '紧张 机器人',
      '紧张 忍者',
      '紧张 小鸡',
      '紧张 章鱼',
      '紧张 喷嚏',
      '紧张 逃跑',
      '紧张 游行',
      '晕乎乎 舞蹈',
      '晕乎乎 走路',
      '晕乎乎 企鹅',
      '晕乎乎 机器人',
      '晕乎乎 忍者',
      '晕乎乎 小鸡',
      '晕乎乎 章鱼',
      '晕乎乎 喷嚏',
      '晕乎乎 逃跑',
      '晕乎乎 游行',
      '搞笑 舞蹈',
      '搞笑 走路',
      '搞笑 企鹅',
      '搞笑 机器人',
      '搞笑 忍者',
      '搞笑 小鸡',
      '搞笑 章鱼',
      '搞笑 喷嚏',
      '搞笑 逃跑',
      '搞笑 游行',
      '滑稽 舞蹈',
      '滑稽 走路',
      '滑稽 企鹅',
      '滑稽 机器人',
      '滑稽 忍者',
      '滑稽 小鸡',
      '滑稽 章鱼',
      '滑稽 喷嚏',
      '滑稽 逃跑',
      '滑稽 游行',
      '尴尬 舞蹈',
      '尴尬 走路',
      '尴尬 企鹅',
      '尴尬 机器人',
      '尴尬 忍者',
      '尴尬 小鸡',
      '尴尬 章鱼',
      '尴尬 喷嚏',
      '尴尬 逃跑',
      '尴尬 游行',
      '夸张 舞蹈',
      '夸张 走路',
      '夸张 企鹅',
      '夸张 机器人',
      '夸张 忍者',
      '夸张 小鸡',
      '夸张 章鱼',
      '夸张 喷嚏',
      '夸张 逃跑',
      '夸张 游行',
      '疯狂 舞蹈',
      '疯狂 走路',
      '疯狂 企鹅',
      '疯狂 机器人',
      '疯狂 忍者',
      '疯狂 小鸡',
      '疯狂 章鱼',
      '疯狂 喷嚏',
      '疯狂 逃跑',
      '疯狂 游行',
      '害羞 舞蹈',
      '害羞 走路',
      '害羞 企鹅',
      '害羞 机器人',
      '害羞 忍者',
      '害羞 小鸡',
      '害羞 章鱼',
      '害羞 喷嚏',
      '害羞 逃跑',
      '害羞 游行'
    ]
  },

  zh_mature: {
    id: 'zh_mature',
    name: '中文 - 18+ 成人',
    description: '仅限成人派对!',
    language: 'zh',
    isPremium: false,
    words: [
      '尴尬 调情',
      '尴尬 拥抱',
      '尴尬 耳语',
      '尴尬 对视',
      '尴尬 依偎',
      '尴尬 亲吻',
      '尴尬 靠近',
      '尴尬 后退',
      '尴尬 慢舞',
      '尴尬 瞬间',
      '暧昧 调情',
      '暧昧 拥抱',
      '暧昧 耳语',
      '暧昧 对视',
      '暧昧 依偎',
      '暧昧 亲吻',
      '暧昧 靠近',
      '暧昧 后退',
      '暧昧 慢舞',
      '暧昧 瞬间',
      '紧张 调情',
      '紧张 拥抱',
      '紧张 耳语',
      '紧张 对视',
      '紧张 依偎',
      '紧张 亲吻',
      '紧张 靠近',
      '紧张 后退',
      '紧张 慢舞',
      '紧张 瞬间',
      '醉醺醺 调情',
      '醉醺醺 拥抱',
      '醉醺醺 耳语',
      '醉醺醺 对视',
      '醉醺醺 依偎',
      '醉醺醺 亲吻',
      '醉醺醺 靠近',
      '醉醺醺 后退',
      '醉醺醺 慢舞',
      '醉醺醺 瞬间',
      '嫉妒 调情',
      '嫉妒 拥抱',
      '嫉妒 耳语',
      '嫉妒 对视',
      '嫉妒 依偎',
      '嫉妒 亲吻',
      '嫉妒 靠近',
      '嫉妒 后退',
      '嫉妒 慢舞',
      '嫉妒 瞬间',
      '大胆 调情',
      '大胆 拥抱',
      '大胆 耳语',
      '大胆 对视',
      '大胆 依偎',
      '大胆 亲吻',
      '大胆 靠近',
      '大胆 后退',
      '大胆 慢舞',
      '大胆 瞬间',
      '害羞 调情',
      '害羞 拥抱',
      '害羞 耳语',
      '害羞 对视',
      '害羞 依偎',
      '害羞 亲吻',
      '害羞 靠近',
      '害羞 后退',
      '害羞 慢舞',
      '害羞 瞬间',
      '紧绷 调情',
      '紧绷 拥抱',
      '紧绷 耳语',
      '紧绷 对视',
      '紧绷 依偎',
      '紧绷 亲吻',
      '紧绷 靠近',
      '紧绷 后退',
      '紧绷 慢舞',
      '紧绷 瞬间',
      '窘迫 调情',
      '窘迫 拥抱',
      '窘迫 耳语',
      '窘迫 对视',
      '窘迫 依偎',
      '窘迫 亲吻',
      '窘迫 靠近',
      '窘迫 后退',
      '窘迫 慢舞',
      '窘迫 瞬间',
      '心动 调情',
      '心动 拥抱',
      '心动 耳语',
      '心动 对视',
      '心动 依偎',
      '心动 亲吻',
      '心动 靠近',
      '心动 后退',
      '心动 慢舞',
      '心动 瞬间'
    ]
  },

  // ============================================
  // SPANISH (es)
  // ============================================
  es_allAges: {
    id: 'es_allAges',
    name: 'Español - Todas las edades',
    description: 'Charadas divertidas para todos',
    language: 'es',
    isPremium: false,
    words: [
      'baile nervioso',
      'caminar nervioso',
      'pingüino nervioso',
      'robot nervioso',
      'ninja nervioso',
      'gallina nervioso',
      'pulpo nervioso',
      'estornudo nervioso',
      'escapada nervioso',
      'desfile nervioso',
      'baile torpe',
      'caminar torpe',
      'pingüino torpe',
      'robot torpe',
      'ninja torpe',
      'gallina torpe',
      'pulpo torpe',
      'estornudo torpe',
      'escapada torpe',
      'desfile torpe',
      'baile pánico',
      'caminar pánico',
      'pingüino pánico',
      'robot pánico',
      'ninja pánico',
      'gallina pánico',
      'pulpo pánico',
      'estornudo pánico',
      'escapada pánico',
      'desfile pánico',
      'baile tambaleante',
      'caminar tambaleante',
      'pingüino tambaleante',
      'robot tambaleante',
      'ninja tambaleante',
      'gallina tambaleante',
      'pulpo tambaleante',
      'estornudo tambaleante',
      'escapada tambaleante',
      'desfile tambaleante',
      'baile somnoliento',
      'caminar somnoliento',
      'pingüino somnoliento',
      'robot somnoliento',
      'ninja somnoliento',
      'gallina somnoliento',
      'pulpo somnoliento',
      'estornudo somnoliento',
      'escapada somnoliento',
      'desfile somnoliento',
      'baile hiperactivo',
      'caminar hiperactivo',
      'pingüino hiperactivo',
      'robot hiperactivo',
      'ninja hiperactivo',
      'gallina hiperactivo',
      'pulpo hiperactivo',
      'estornudo hiperactivo',
      'escapada hiperactivo',
      'desfile hiperactivo',
      'baile sigiloso',
      'caminar sigiloso',
      'pingüino sigiloso',
      'robot sigiloso',
      'ninja sigiloso',
      'gallina sigiloso',
      'pulpo sigiloso',
      'estornudo sigiloso',
      'escapada sigiloso',
      'desfile sigiloso',
      'baile congelado',
      'caminar congelado',
      'pingüino congelado',
      'robot congelado',
      'ninja congelado',
      'gallina congelado',
      'pulpo congelado',
      'estornudo congelado',
      'escapada congelado',
      'desfile congelado',
      'baile incómodo',
      'caminar incómodo',
      'pingüino incómodo',
      'robot incómodo',
      'ninja incómodo',
      'gallina incómodo',
      'pulpo incómodo',
      'estornudo incómodo',
      'escapada incómodo',
      'desfile incómodo',
      'baile dramático',
      'caminar dramático',
      'pingüino dramático',
      'robot dramático',
      'ninja dramático',
      'gallina dramático',
      'pulpo dramático',
      'estornudo dramático',
      'escapada dramático',
      'desfile dramático'
    ]
  },

  es_mature: {
    id: 'es_mature',
    name: 'Español - 18+ Adultos',
    description: '¡Solo para fiestas de adultos!',
    language: 'es',
    isPremium: false,
    words: [
      'coqueteo torpe',
      'abrazo torpe',
      'susurro torpe',
      'mirada torpe',
      'cariño torpe',
      'beso torpe',
      'acercamiento torpe',
      'retirada torpe',
      'baile torpe',
      'momento torpe',
      'coqueteo atrevido',
      'abrazo atrevido',
      'susurro atrevido',
      'mirada atrevido',
      'cariño atrevido',
      'beso atrevido',
      'acercamiento atrevido',
      'retirada atrevido',
      'baile atrevido',
      'momento atrevido',
      'coqueteo tenso',
      'abrazo tenso',
      'susurro tenso',
      'mirada tenso',
      'cariño tenso',
      'beso tenso',
      'acercamiento tenso',
      'retirada tenso',
      'baile tenso',
      'momento tenso',
      'coqueteo celoso',
      'abrazo celoso',
      'susurro celoso',
      'mirada celoso',
      'cariño celoso',
      'beso celoso',
      'acercamiento celoso',
      'retirada celoso',
      'baile celoso',
      'momento celoso',
      'coqueteo vergonzoso',
      'abrazo vergonzoso',
      'susurro vergonzoso',
      'mirada vergonzoso',
      'cariño vergonzoso',
      'beso vergonzoso',
      'acercamiento vergonzoso',
      'retirada vergonzoso',
      'baile vergonzoso',
      'momento vergonzoso',
      'coqueteo nervioso',
      'abrazo nervioso',
      'susurro nervioso',
      'mirada nervioso',
      'cariño nervioso',
      'beso nervioso',
      'acercamiento nervioso',
      'retirada nervioso',
      'baile nervioso',
      'momento nervioso',
      'coqueteo tímido',
      'abrazo tímido',
      'susurro tímido',
      'mirada tímido',
      'cariño tímido',
      'beso tímido',
      'acercamiento tímido',
      'retirada tímido',
      'baile tímido',
      'momento tímido',
      'coqueteo apasionado',
      'abrazo apasionado',
      'susurro apasionado',
      'mirada apasionado',
      'cariño apasionado',
      'beso apasionado',
      'acercamiento apasionado',
      'retirada apasionado',
      'baile apasionado',
      'momento apasionado',
      'coqueteo incómodo',
      'abrazo incómodo',
      'susurro incómodo',
      'mirada incómodo',
      'cariño incómodo',
      'beso incómodo',
      'acercamiento incómodo',
      'retirada incómodo',
      'baile incómodo',
      'momento incómodo',
      'coqueteo secreto',
      'abrazo secreto',
      'susurro secreto',
      'mirada secreto',
      'cariño secreto',
      'beso secreto',
      'acercamiento secreto',
      'retirada secreto',
      'baile secreto',
      'momento secreto'
    ]
  },

  // ============================================
  // PORTUGUESE (pt)
  // ============================================
  pt_allAges: {
    id: 'pt_allAges',
    name: 'Português - Todas as idades',
    description: 'Mímica divertida para todos',
    language: 'pt',
    isPremium: false,
    words: [
      'dança nervosa',
      'caminhada nervosa',
      'pinguim nervosa',
      'robô nervosa',
      'ninja nervosa',
      'galinha nervosa',
      'polvo nervosa',
      'espirro nervosa',
      'fuga nervosa',
      'desfile nervosa',
      'dança desajeitada',
      'caminhada desajeitada',
      'pinguim desajeitada',
      'robô desajeitada',
      'ninja desajeitada',
      'galinha desajeitada',
      'polvo desajeitada',
      'espirro desajeitada',
      'fuga desajeitada',
      'desfile desajeitada',
      'dança em pânico',
      'caminhada em pânico',
      'pinguim em pânico',
      'robô em pânico',
      'ninja em pânico',
      'galinha em pânico',
      'polvo em pânico',
      'espirro em pânico',
      'fuga em pânico',
      'desfile em pânico',
      'dança bamba',
      'caminhada bamba',
      'pinguim bamba',
      'robô bamba',
      'ninja bamba',
      'galinha bamba',
      'polvo bamba',
      'espirro bamba',
      'fuga bamba',
      'desfile bamba',
      'dança sonolenta',
      'caminhada sonolenta',
      'pinguim sonolenta',
      'robô sonolenta',
      'ninja sonolenta',
      'galinha sonolenta',
      'polvo sonolenta',
      'espirro sonolenta',
      'fuga sonolenta',
      'desfile sonolenta',
      'dança elétrica',
      'caminhada elétrica',
      'pinguim elétrica',
      'robô elétrica',
      'ninja elétrica',
      'galinha elétrica',
      'polvo elétrica',
      'espirro elétrica',
      'fuga elétrica',
      'desfile elétrica',
      'dança sorrateira',
      'caminhada sorrateira',
      'pinguim sorrateira',
      'robô sorrateira',
      'ninja sorrateira',
      'galinha sorrateira',
      'polvo sorrateira',
      'espirro sorrateira',
      'fuga sorrateira',
      'desfile sorrateira',
      'dança congelada',
      'caminhada congelada',
      'pinguim congelada',
      'robô congelada',
      'ninja congelada',
      'galinha congelada',
      'polvo congelada',
      'espirro congelada',
      'fuga congelada',
      'desfile congelada',
      'dança estranha',
      'caminhada estranha',
      'pinguim estranha',
      'robô estranha',
      'ninja estranha',
      'galinha estranha',
      'polvo estranha',
      'espirro estranha',
      'fuga estranha',
      'desfile estranha',
      'dança dramática',
      'caminhada dramática',
      'pinguim dramática',
      'robô dramática',
      'ninja dramática',
      'galinha dramática',
      'polvo dramática',
      'espirro dramática',
      'fuga dramática',
      'desfile dramática'
    ]
  },

  pt_mature: {
    id: 'pt_mature',
    name: 'Português - 18+ Adultos',
    description: 'Apenas para festas de adultos!',
    language: 'pt',
    isPremium: false,
    words: [
      'paquera desajeitada',
      'abraço desajeitada',
      'sussurro desajeitada',
      'olhar desajeitada',
      'carinho desajeitada',
      'beijo desajeitada',
      'aproximação desajeitada',
      'retirada desajeitada',
      'dança desajeitada',
      'momento desajeitada',
      'paquera ousada',
      'abraço ousada',
      'sussurro ousada',
      'olhar ousada',
      'carinho ousada',
      'beijo ousada',
      'aproximação ousada',
      'retirada ousada',
      'dança ousada',
      'momento ousada',
      'paquera tensa',
      'abraço tensa',
      'sussurro tensa',
      'olhar tensa',
      'carinho tensa',
      'beijo tensa',
      'aproximação tensa',
      'retirada tensa',
      'dança tensa',
      'momento tensa',
      'paquera ciumenta',
      'abraço ciumenta',
      'sussurro ciumenta',
      'olhar ciumenta',
      'carinho ciumenta',
      'beijo ciumenta',
      'aproximação ciumenta',
      'retirada ciumenta',
      'dança ciumenta',
      'momento ciumenta',
      'paquera envergonhada',
      'abraço envergonhada',
      'sussurro envergonhada',
      'olhar envergonhada',
      'carinho envergonhada',
      'beijo envergonhada',
      'aproximação envergonhada',
      'retirada envergonhada',
      'dança envergonhada',
      'momento envergonhada',
      'paquera nervosa',
      'abraço nervosa',
      'sussurro nervosa',
      'olhar nervosa',
      'carinho nervosa',
      'beijo nervosa',
      'aproximação nervosa',
      'retirada nervosa',
      'dança nervosa',
      'momento nervosa',
      'paquera tímida',
      'abraço tímida',
      'sussurro tímida',
      'olhar tímida',
      'carinho tímida',
      'beijo tímida',
      'aproximação tímida',
      'retirada tímida',
      'dança tímida',
      'momento tímida',
      'paquera calorosa',
      'abraço calorosa',
      'sussurro calorosa',
      'olhar calorosa',
      'carinho calorosa',
      'beijo calorosa',
      'aproximação calorosa',
      'retirada calorosa',
      'dança calorosa',
      'momento calorosa',
      'paquera complicada',
      'abraço complicada',
      'sussurro complicada',
      'olhar complicada',
      'carinho complicada',
      'beijo complicada',
      'aproximação complicada',
      'retirada complicada',
      'dança complicada',
      'momento complicada',
      'paquera secreta',
      'abraço secreta',
      'sussurro secreta',
      'olhar secreta',
      'carinho secreta',
      'beijo secreta',
      'aproximação secreta',
      'retirada secreta',
      'dança secreta',
      'momento secreta'
    ]
  },

  // ============================================
  // ITALIAN (it)
  // ============================================
  it_allAges: {
    id: 'it_allAges',
    name: 'Italiano - Tutte le età',
    description: 'Mimo divertente per tutti',
    language: 'it',
    isPremium: false,
    words: [
      'ballo nervoso',
      'camminata nervoso',
      'pinguino nervoso',
      'robot nervoso',
      'ninja nervoso',
      'gallina nervoso',
      'polpo nervoso',
      'starnuto nervoso',
      'fuga nervoso',
      'parata nervoso',
      'ballo goffo',
      'camminata goffo',
      'pinguino goffo',
      'robot goffo',
      'ninja goffo',
      'gallina goffo',
      'polpo goffo',
      'starnuto goffo',
      'fuga goffo',
      'parata goffo',
      'ballo in panico',
      'camminata in panico',
      'pinguino in panico',
      'robot in panico',
      'ninja in panico',
      'gallina in panico',
      'polpo in panico',
      'starnuto in panico',
      'fuga in panico',
      'parata in panico',
      'ballo traballante',
      'camminata traballante',
      'pinguino traballante',
      'robot traballante',
      'ninja traballante',
      'gallina traballante',
      'polpo traballante',
      'starnuto traballante',
      'fuga traballante',
      'parata traballante',
      'ballo assonnato',
      'camminata assonnato',
      'pinguino assonnato',
      'robot assonnato',
      'ninja assonnato',
      'gallina assonnato',
      'polpo assonnato',
      'starnuto assonnato',
      'fuga assonnato',
      'parata assonnato',
      'ballo iperattivo',
      'camminata iperattivo',
      'pinguino iperattivo',
      'robot iperattivo',
      'ninja iperattivo',
      'gallina iperattivo',
      'polpo iperattivo',
      'starnuto iperattivo',
      'fuga iperattivo',
      'parata iperattivo',
      'ballo furtivo',
      'camminata furtivo',
      'pinguino furtivo',
      'robot furtivo',
      'ninja furtivo',
      'gallina furtivo',
      'polpo furtivo',
      'starnuto furtivo',
      'fuga furtivo',
      'parata furtivo',
      'ballo congelato',
      'camminata congelato',
      'pinguino congelato',
      'robot congelato',
      'ninja congelato',
      'gallina congelato',
      'polpo congelato',
      'starnuto congelato',
      'fuga congelato',
      'parata congelato',
      'ballo imbarazzante',
      'camminata imbarazzante',
      'pinguino imbarazzante',
      'robot imbarazzante',
      'ninja imbarazzante',
      'gallina imbarazzante',
      'polpo imbarazzante',
      'starnuto imbarazzante',
      'fuga imbarazzante',
      'parata imbarazzante',
      'ballo drammatico',
      'camminata drammatico',
      'pinguino drammatico',
      'robot drammatico',
      'ninja drammatico',
      'gallina drammatico',
      'polpo drammatico',
      'starnuto drammatico',
      'fuga drammatico',
      'parata drammatico'
    ]
  },

  it_mature: {
    id: 'it_mature',
    name: 'Italiano - 18+ Adulti',
    description: 'Solo per feste di adulti!',
    language: 'it',
    isPremium: false,
    words: [
      'flirt goffo',
      'abbraccio goffo',
      'sussurro goffo',
      'sguardo goffo',
      'coccola goffo',
      'bacio goffo',
      'avvicinamento goffo',
      'ritirata goffo',
      'ballo goffo',
      'momento goffo',
      'flirt audace',
      'abbraccio audace',
      'sussurro audace',
      'sguardo audace',
      'coccola audace',
      'bacio audace',
      'avvicinamento audace',
      'ritirata audace',
      'ballo audace',
      'momento audace',
      'flirt teso',
      'abbraccio teso',
      'sussurro teso',
      'sguardo teso',
      'coccola teso',
      'bacio teso',
      'avvicinamento teso',
      'ritirata teso',
      'ballo teso',
      'momento teso',
      'flirt geloso',
      'abbraccio geloso',
      'sussurro geloso',
      'sguardo geloso',
      'coccola geloso',
      'bacio geloso',
      'avvicinamento geloso',
      'ritirata geloso',
      'ballo geloso',
      'momento geloso',
      'flirt imbarazzato',
      'abbraccio imbarazzato',
      'sussurro imbarazzato',
      'sguardo imbarazzato',
      'coccola imbarazzato',
      'bacio imbarazzato',
      'avvicinamento imbarazzato',
      'ritirata imbarazzato',
      'ballo imbarazzato',
      'momento imbarazzato',
      'flirt nervoso',
      'abbraccio nervoso',
      'sussurro nervoso',
      'sguardo nervoso',
      'coccola nervoso',
      'bacio nervoso',
      'avvicinamento nervoso',
      'ritirata nervoso',
      'ballo nervoso',
      'momento nervoso',
      'flirt timido',
      'abbraccio timido',
      'sussurro timido',
      'sguardo timido',
      'coccola timido',
      'bacio timido',
      'avvicinamento timido',
      'ritirata timido',
      'ballo timido',
      'momento timido',
      'flirt appassionato',
      'abbraccio appassionato',
      'sussurro appassionato',
      'sguardo appassionato',
      'coccola appassionato',
      'bacio appassionato',
      'avvicinamento appassionato',
      'ritirata appassionato',
      'ballo appassionato',
      'momento appassionato',
      'flirt complicato',
      'abbraccio complicato',
      'sussurro complicato',
      'sguardo complicato',
      'coccola complicato',
      'bacio complicato',
      'avvicinamento complicato',
      'ritirata complicato',
      'ballo complicato',
      'momento complicato',
      'flirt segreto',
      'abbraccio segreto',
      'sussurro segreto',
      'sguardo segreto',
      'coccola segreto',
      'bacio segreto',
      'avvicinamento segreto',
      'ritirata segreto',
      'ballo segreto',
      'momento segreto'
    ]
  },

  // ============================================
  // GERMAN (de)
  // ============================================
  de_allAges: {
    id: 'de_allAges',
    name: 'Deutsch - Alle Altersgruppen',
    description: 'Lustige Scharade für alle',
    language: 'de',
    isPremium: false,
    words: [
      'nervös Tanz',
      'nervös Gang',
      'nervös Pinguin',
      'nervös Roboter',
      'nervös Ninja',
      'nervös Huhn',
      'nervös Oktopus',
      'nervös Niesen',
      'nervös Flucht',
      'nervös Parade',
      'tollpatschig Tanz',
      'tollpatschig Gang',
      'tollpatschig Pinguin',
      'tollpatschig Roboter',
      'tollpatschig Ninja',
      'tollpatschig Huhn',
      'tollpatschig Oktopus',
      'tollpatschig Niesen',
      'tollpatschig Flucht',
      'tollpatschig Parade',
      'panisch Tanz',
      'panisch Gang',
      'panisch Pinguin',
      'panisch Roboter',
      'panisch Ninja',
      'panisch Huhn',
      'panisch Oktopus',
      'panisch Niesen',
      'panisch Flucht',
      'panisch Parade',
      'wackelig Tanz',
      'wackelig Gang',
      'wackelig Pinguin',
      'wackelig Roboter',
      'wackelig Ninja',
      'wackelig Huhn',
      'wackelig Oktopus',
      'wackelig Niesen',
      'wackelig Flucht',
      'wackelig Parade',
      'schläfrig Tanz',
      'schläfrig Gang',
      'schläfrig Pinguin',
      'schläfrig Roboter',
      'schläfrig Ninja',
      'schläfrig Huhn',
      'schläfrig Oktopus',
      'schläfrig Niesen',
      'schläfrig Flucht',
      'schläfrig Parade',
      'hyperaktiv Tanz',
      'hyperaktiv Gang',
      'hyperaktiv Pinguin',
      'hyperaktiv Roboter',
      'hyperaktiv Ninja',
      'hyperaktiv Huhn',
      'hyperaktiv Oktopus',
      'hyperaktiv Niesen',
      'hyperaktiv Flucht',
      'hyperaktiv Parade',
      'schleichend Tanz',
      'schleichend Gang',
      'schleichend Pinguin',
      'schleichend Roboter',
      'schleichend Ninja',
      'schleichend Huhn',
      'schleichend Oktopus',
      'schleichend Niesen',
      'schleichend Flucht',
      'schleichend Parade',
      'eingefroren Tanz',
      'eingefroren Gang',
      'eingefroren Pinguin',
      'eingefroren Roboter',
      'eingefroren Ninja',
      'eingefroren Huhn',
      'eingefroren Oktopus',
      'eingefroren Niesen',
      'eingefroren Flucht',
      'eingefroren Parade',
      'peinlich Tanz',
      'peinlich Gang',
      'peinlich Pinguin',
      'peinlich Roboter',
      'peinlich Ninja',
      'peinlich Huhn',
      'peinlich Oktopus',
      'peinlich Niesen',
      'peinlich Flucht',
      'peinlich Parade',
      'dramatisch Tanz',
      'dramatisch Gang',
      'dramatisch Pinguin',
      'dramatisch Roboter',
      'dramatisch Ninja',
      'dramatisch Huhn',
      'dramatisch Oktopus',
      'dramatisch Niesen',
      'dramatisch Flucht',
      'dramatisch Parade'
    ]
  },

  de_mature: {
    id: 'de_mature',
    name: 'Deutsch - 18+ Erwachsene',
    description: 'Nur für Erwachsenenpartys!',
    language: 'de',
    isPremium: false,
    words: [
      'peinlich Flirt',
      'peinlich Umarmung',
      'peinlich Flüstern',
      'peinlich Blick',
      'peinlich Kuscheln',
      'peinlich Kuss',
      'peinlich Annäherung',
      'peinlich Rückzug',
      'peinlich Tanz',
      'peinlich Moment',
      'flirty Flirt',
      'flirty Umarmung',
      'flirty Flüstern',
      'flirty Blick',
      'flirty Kuscheln',
      'flirty Kuss',
      'flirty Annäherung',
      'flirty Rückzug',
      'flirty Tanz',
      'flirty Moment',
      'nervös Flirt',
      'nervös Umarmung',
      'nervös Flüstern',
      'nervös Blick',
      'nervös Kuscheln',
      'nervös Kuss',
      'nervös Annäherung',
      'nervös Rückzug',
      'nervös Tanz',
      'nervös Moment',
      'betrunken Flirt',
      'betrunken Umarmung',
      'betrunken Flüstern',
      'betrunken Blick',
      'betrunken Kuscheln',
      'betrunken Kuss',
      'betrunken Annäherung',
      'betrunken Rückzug',
      'betrunken Tanz',
      'betrunken Moment',
      'eifersüchtig Flirt',
      'eifersüchtig Umarmung',
      'eifersüchtig Flüstern',
      'eifersüchtig Blick',
      'eifersüchtig Kuscheln',
      'eifersüchtig Kuss',
      'eifersüchtig Annäherung',
      'eifersüchtig Rückzug',
      'eifersüchtig Tanz',
      'eifersüchtig Moment',
      'schüchtern Flirt',
      'schüchtern Umarmung',
      'schüchtern Flüstern',
      'schüchtern Blick',
      'schüchtern Kuscheln',
      'schüchtern Kuss',
      'schüchtern Annäherung',
      'schüchtern Rückzug',
      'schüchtern Tanz',
      'schüchtern Moment',
      'mutig Flirt',
      'mutig Umarmung',
      'mutig Flüstern',
      'mutig Blick',
      'mutig Kuscheln',
      'mutig Kuss',
      'mutig Annäherung',
      'mutig Rückzug',
      'mutig Tanz',
      'mutig Moment',
      'angespannt Flirt',
      'angespannt Umarmung',
      'angespannt Flüstern',
      'angespannt Blick',
      'angespannt Kuscheln',
      'angespannt Kuss',
      'angespannt Annäherung',
      'angespannt Rückzug',
      'angespannt Tanz',
      'angespannt Moment',
      'verlegen Flirt',
      'verlegen Umarmung',
      'verlegen Flüstern',
      'verlegen Blick',
      'verlegen Kuscheln',
      'verlegen Kuss',
      'verlegen Annäherung',
      'verlegen Rückzug',
      'verlegen Tanz',
      'verlegen Moment',
      'heimlich Flirt',
      'heimlich Umarmung',
      'heimlich Flüstern',
      'heimlich Blick',
      'heimlich Kuscheln',
      'heimlich Kuss',
      'heimlich Annäherung',
      'heimlich Rückzug',
      'heimlich Tanz',
      'heimlich Moment'
    ]
  },

  // ============================================
  // FRENCH (fr)
  // ============================================
  fr_allAges: {
    id: 'fr_allAges',
    name: 'Français - Tout public',
    description: 'Charades amusantes pour tous',
    language: 'fr',
    isPremium: false,
    words: [
      'danse nerveuse',
      'marche nerveuse',
      'pingouin nerveuse',
      'robot nerveuse',
      'ninja nerveuse',
      'poule nerveuse',
      'pieuvre nerveuse',
      'éternuement nerveuse',
      'fuite nerveuse',
      'parade nerveuse',
      'danse maladroite',
      'marche maladroite',
      'pingouin maladroite',
      'robot maladroite',
      'ninja maladroite',
      'poule maladroite',
      'pieuvre maladroite',
      'éternuement maladroite',
      'fuite maladroite',
      'parade maladroite',
      'danse panique',
      'marche panique',
      'pingouin panique',
      'robot panique',
      'ninja panique',
      'poule panique',
      'pieuvre panique',
      'éternuement panique',
      'fuite panique',
      'parade panique',
      'danse chancelante',
      'marche chancelante',
      'pingouin chancelante',
      'robot chancelante',
      'ninja chancelante',
      'poule chancelante',
      'pieuvre chancelante',
      'éternuement chancelante',
      'fuite chancelante',
      'parade chancelante',
      'danse endormie',
      'marche endormie',
      'pingouin endormie',
      'robot endormie',
      'ninja endormie',
      'poule endormie',
      'pieuvre endormie',
      'éternuement endormie',
      'fuite endormie',
      'parade endormie',
      'danse hyperactive',
      'marche hyperactive',
      'pingouin hyperactive',
      'robot hyperactive',
      'ninja hyperactive',
      'poule hyperactive',
      'pieuvre hyperactive',
      'éternuement hyperactive',
      'fuite hyperactive',
      'parade hyperactive',
      'danse discrète',
      'marche discrète',
      'pingouin discrète',
      'robot discrète',
      'ninja discrète',
      'poule discrète',
      'pieuvre discrète',
      'éternuement discrète',
      'fuite discrète',
      'parade discrète',
      'danse figée',
      'marche figée',
      'pingouin figée',
      'robot figée',
      'ninja figée',
      'poule figée',
      'pieuvre figée',
      'éternuement figée',
      'fuite figée',
      'parade figée',
      'danse gênante',
      'marche gênante',
      'pingouin gênante',
      'robot gênante',
      'ninja gênante',
      'poule gênante',
      'pieuvre gênante',
      'éternuement gênante',
      'fuite gênante',
      'parade gênante',
      'danse dramatique',
      'marche dramatique',
      'pingouin dramatique',
      'robot dramatique',
      'ninja dramatique',
      'poule dramatique',
      'pieuvre dramatique',
      'éternuement dramatique',
      'fuite dramatique',
      'parade dramatique'
    ]
  },

  fr_mature: {
    id: 'fr_mature',
    name: 'Français - 18+ Adultes',
    description: 'Uniquement pour les fêtes adultes!',
    language: 'fr',
    isPremium: false,
    words: [
      'drague maladroite',
      'câlin maladroite',
      'murmure maladroite',
      'regard maladroite',
      'tendresse maladroite',
      'baiser maladroite',
      'approche maladroite',
      'retrait maladroite',
      'slow maladroite',
      'moment maladroite',
      'drague audacieuse',
      'câlin audacieuse',
      'murmure audacieuse',
      'regard audacieuse',
      'tendresse audacieuse',
      'baiser audacieuse',
      'approche audacieuse',
      'retrait audacieuse',
      'slow audacieuse',
      'moment audacieuse',
      'drague tendue',
      'câlin tendue',
      'murmure tendue',
      'regard tendue',
      'tendresse tendue',
      'baiser tendue',
      'approche tendue',
      'retrait tendue',
      'slow tendue',
      'moment tendue',
      'drague jalouse',
      'câlin jalouse',
      'murmure jalouse',
      'regard jalouse',
      'tendresse jalouse',
      'baiser jalouse',
      'approche jalouse',
      'retrait jalouse',
      'slow jalouse',
      'moment jalouse',
      'drague gênée',
      'câlin gênée',
      'murmure gênée',
      'regard gênée',
      'tendresse gênée',
      'baiser gênée',
      'approche gênée',
      'retrait gênée',
      'slow gênée',
      'moment gênée',
      'drague nerveuse',
      'câlin nerveuse',
      'murmure nerveuse',
      'regard nerveuse',
      'tendresse nerveuse',
      'baiser nerveuse',
      'approche nerveuse',
      'retrait nerveuse',
      'slow nerveuse',
      'moment nerveuse',
      'drague timide',
      'câlin timide',
      'murmure timide',
      'regard timide',
      'tendresse timide',
      'baiser timide',
      'approche timide',
      'retrait timide',
      'slow timide',
      'moment timide',
      'drague passionnée',
      'câlin passionnée',
      'murmure passionnée',
      'regard passionnée',
      'tendresse passionnée',
      'baiser passionnée',
      'approche passionnée',
      'retrait passionnée',
      'slow passionnée',
      'moment passionnée',
      'drague compliquée',
      'câlin compliquée',
      'murmure compliquée',
      'regard compliquée',
      'tendresse compliquée',
      'baiser compliquée',
      'approche compliquée',
      'retrait compliquée',
      'slow compliquée',
      'moment compliquée',
      'drague secrète',
      'câlin secrète',
      'murmure secrète',
      'regard secrète',
      'tendresse secrète',
      'baiser secrète',
      'approche secrète',
      'retrait secrète',
      'slow secrète',
      'moment secrète'
    ]
  },

  // ============================================
  // JAPANESE (ja) - NEW LANGUAGE
  // ============================================
  ja_allAges: {
    id: 'ja_allAges',
    name: '日本語 - 全年齢',
    description: '誰でも楽しめるジェスチャーゲーム',
    language: 'ja',
    isPremium: false,
    words: [
      'パニック ダンス',
      'パニック 歩き',
      'パニック ペンギン',
      'パニック ロボット',
      'パニック ニンジャ',
      'パニック チキン',
      'パニック タコ',
      'パニック くしゃみ',
      'パニック にげみち',
      'パニック パレード',
      'へんてこ ダンス',
      'へんてこ 歩き',
      'へんてこ ペンギン',
      'へんてこ ロボット',
      'へんてこ ニンジャ',
      'へんてこ チキン',
      'へんてこ タコ',
      'へんてこ くしゃみ',
      'へんてこ にげみち',
      'へんてこ パレード',
      'あわてた ダンス',
      'あわてた 歩き',
      'あわてた ペンギン',
      'あわてた ロボット',
      'あわてた ニンジャ',
      'あわてた チキン',
      'あわてた タコ',
      'あわてた くしゃみ',
      'あわてた にげみち',
      'あわてた パレード',
      'ぎこちない ダンス',
      'ぎこちない 歩き',
      'ぎこちない ペンギン',
      'ぎこちない ロボット',
      'ぎこちない ニンジャ',
      'ぎこちない チキン',
      'ぎこちない タコ',
      'ぎこちない くしゃみ',
      'ぎこちない にげみち',
      'ぎこちない パレード',
      'ねむそう ダンス',
      'ねむそう 歩き',
      'ねむそう ペンギン',
      'ねむそう ロボット',
      'ねむそう ニンジャ',
      'ねむそう チキン',
      'ねむそう タコ',
      'ねむそう くしゃみ',
      'ねむそう にげみち',
      'ねむそう パレード',
      'ハイテンション ダンス',
      'ハイテンション 歩き',
      'ハイテンション ペンギン',
      'ハイテンション ロボット',
      'ハイテンション ニンジャ',
      'ハイテンション チキン',
      'ハイテンション タコ',
      'ハイテンション くしゃみ',
      'ハイテンション にげみち',
      'ハイテンション パレード',
      'こっそり ダンス',
      'こっそり 歩き',
      'こっそり ペンギン',
      'こっそり ロボット',
      'こっそり ニンジャ',
      'こっそり チキン',
      'こっそり タコ',
      'こっそり くしゃみ',
      'こっそり にげみち',
      'こっそり パレード',
      'フリーズ ダンス',
      'フリーズ 歩き',
      'フリーズ ペンギン',
      'フリーズ ロボット',
      'フリーズ ニンジャ',
      'フリーズ チキン',
      'フリーズ タコ',
      'フリーズ くしゃみ',
      'フリーズ にげみち',
      'フリーズ パレード',
      'きまりわるい ダンス',
      'きまりわるい 歩き',
      'きまりわるい ペンギン',
      'きまりわるい ロボット',
      'きまりわるい ニンジャ',
      'きまりわるい チキン',
      'きまりわるい タコ',
      'きまりわるい くしゃみ',
      'きまりわるい にげみち',
      'きまりわるい パレード',
      'ドラマチック ダンス',
      'ドラマチック 歩き',
      'ドラマチック ペンギン',
      'ドラマチック ロボット',
      'ドラマチック ニンジャ',
      'ドラマチック チキン',
      'ドラマチック タコ',
      'ドラマチック くしゃみ',
      'ドラマチック にげみち',
      'ドラマチック パレード'
    ]
  },

  ja_mature: {
    id: 'ja_mature',
    name: '日本語 - 18+ 大人向け',
    description: '大人のパーティー専用!',
    language: 'ja',
    isPremium: false,
    words: [
      // Fixed expressions (replaced フラirty with いちゃいちゃ - proper Japanese for flirty)
      'ぎこちない ナンパ',
      'ぎこちない ハグ',
      'ぎこちない ささやき',
      'ぎこちない じっと見',
      'ぎこちない ハグタイム',
      'ぎこちない キス',
      'ぎこちない ちかづき',
      'ぎこちない ひきさがり',
      'ぎこちない スローダンス',
      'ぎこちない しゅんかん',
      'いちゃいちゃ ナンパ',
      'いちゃいちゃ ハグ',
      'いちゃいちゃ ささやき',
      'いちゃいちゃ じっと見',
      'いちゃいちゃ ハグタイム',
      'いちゃいちゃ キス',
      'いちゃいちゃ ちかづき',
      'いちゃいちゃ ひきさがり',
      'いちゃいちゃ スローダンス',
      'いちゃいちゃ しゅんかん',
      'どきどき ナンパ',
      'どきどき ハグ',
      'どきどき ささやき',
      'どきどき じっと見',
      'どきどき ハグタイム',
      'どきどき キス',
      'どきどき ちかづき',
      'どきどき ひきさがり',
      'どきどき スローダンス',
      'どきどき しゅんかん',
      'よっぱらい ナンパ',
      'よっぱらい ハグ',
      'よっぱらい ささやき',
      'よっぱらい じっと見',
      'よっぱらい ハグタイム',
      'よっぱらい キス',
      'よっぱらい ちかづき',
      'よっぱらい ひきさがり',
      'よっぱらい スローダンス',
      'よっぱらい しゅんかん',
      'やきもち ナンパ',
      'やきもち ハグ',
      'やきもち ささやき',
      'やきもち じっと見',
      'やきもち ハグタイム',
      'やきもち キス',
      'やきもち ちかづき',
      'やきもち ひきさがり',
      'やきもち スローダンス',
      'やきもち しゅんかん',
      'はずかしい ナンパ',
      'はずかしい ハグ',
      'はずかしい ささやき',
      'はずかしい じっと見',
      'はずかしい ハグタイム',
      'はずかしい キス',
      'はずかしい ちかづき',
      'はずかしい ひきさがり',
      'はずかしい スローダンス',
      'はずかしい しゅんかん',
      'おとなしい ナンパ',
      'おとなしい ハグ',
      'おとなしい ささやき',
      'おとなしい じっと見',
      'おとなしい ハグタイム',
      'おとなしい キス',
      'おとなしい ちかづき',
      'おとなしい ひきさがり',
      'おとなしい スローダンス',
      'おとなしい しゅんかん',
      'あつい ナンパ',
      'あつい ハグ',
      'あつい ささやき',
      'あつい じっと見',
      'あつい ハグタイム',
      'あつい キス',
      'あつい ちかづき',
      'あつい ひきさがり',
      'あつい スローダンス',
      'あつい しゅんかん',
      'きんちょう ナンパ',
      'きんちょう ハグ',
      'きんちょう ささやき',
      'きんちょう じっと見',
      'きんちょう ハグタイム',
      'きんちょう キス',
      'きんちょう ちかづき',
      'きんちょう ひきさがり',
      'きんちょう スローダンス',
      'きんちょう しゅんかん',
      'ひみつ ナンパ',
      'ひみつ ハグ',
      'ひみつ ささやき',
      'ひみつ じっと見',
      'ひみつ ハグタイム',
      'ひみつ キス',
      'ひみつ ちかづき',
      'ひみつ ひきさがり',
      'ひみつ スローダンス',
      'ひみつ しゅんかん'
    ]
  },

  // ============================================
  // RUSSIAN (ru) - NEW LANGUAGE
  // ============================================
  ru_allAges: {
    id: 'ru_allAges',
    name: 'Русский - Для всех',
    description: 'Весёлые шарады для всех возрастов',
    language: 'ru',
    isPremium: false,
    words: [
      'нервный танец',
      'нервный походка',
      'нервный пингвин',
      'нервный робот',
      'нервный ниндзя',
      'нервный курица',
      'нервный осьминог',
      'нервный чихание',
      'нервный побег',
      'нервный парад',
      'неуклюжий танец',
      'неуклюжий походка',
      'неуклюжий пингвин',
      'неуклюжий робот',
      'неуклюжий ниндзя',
      'неуклюжий курица',
      'неуклюжий осьминог',
      'неуклюжий чихание',
      'неуклюжий побег',
      'неуклюжий парад',
      'панический танец',
      'панический походка',
      'панический пингвин',
      'панический робот',
      'панический ниндзя',
      'панический курица',
      'панический осьминог',
      'панический чихание',
      'панический побег',
      'панический парад',
      'шатающийся танец',
      'шатающийся походка',
      'шатающийся пингвин',
      'шатающийся робот',
      'шатающийся ниндзя',
      'шатающийся курица',
      'шатающийся осьминог',
      'шатающийся чихание',
      'шатающийся побег',
      'шатающийся парад',
      'сонный танец',
      'сонный походка',
      'сонный пингвин',
      'сонный робот',
      'сонный ниндзя',
      'сонный курица',
      'сонный осьминог',
      'сонный чихание',
      'сонный побег',
      'сонный парад',
      'гиперактивный танец',
      'гиперактивный походка',
      'гиперактивный пингвин',
      'гиперактивный робот',
      'гиперактивный ниндзя',
      'гиперактивный курица',
      'гиперактивный осьминог',
      'гиперактивный чихание',
      'гиперактивный побег',
      'гиперактивный парад',
      'крадущийся танец',
      'крадущийся походка',
      'крадущийся пингвин',
      'крадущийся робот',
      'крадущийся ниндзя',
      'крадущийся курица',
      'крадущийся осьминог',
      'крадущийся чихание',
      'крадущийся побег',
      'крадущийся парад',
      'замёрзший танец',
      'замёрзший походка',
      'замёрзший пингвин',
      'замёрзший робот',
      'замёрзший ниндзя',
      'замёрзший курица',
      'замёрзший осьминог',
      'замёрзший чихание',
      'замёрзший побег',
      'замёрзший парад',
      'неловкий танец',
      'неловкий походка',
      'неловкий пингвин',
      'неловкий робот',
      'неловкий ниндзя',
      'неловкий курица',
      'неловкий осьминог',
      'неловкий чихание',
      'неловкий побег',
      'неловкий парад',
      'драматичный танец',
      'драматичный походка',
      'драматичный пингвин',
      'драматичный робот',
      'драматичный ниндзя',
      'драматичный курица',
      'драматичный осьминог',
      'драматичный чихание',
      'драматичный побег',
      'драматичный парад'
    ]
  },

  ru_mature: {
    id: 'ru_mature',
    name: 'Русский - 18+ Взрослые',
    description: 'Только для взрослых вечеринок!',
    language: 'ru',
    isPremium: false,
    words: [
      'неловкий флирт',
      'неловкий объятие',
      'неловкий шёпот',
      'неловкий взгляд',
      'неловкий ласка',
      'неловкий поцелуй',
      'неловкий сближение',
      'неловкий отступление',
      'неловкий танец',
      'неловкий момент',
      'кокетливый флирт',
      'кокетливый объятие',
      'кокетливый шёпот',
      'кокетливый взгляд',
      'кокетливый ласка',
      'кокетливый поцелуй',
      'кокетливый сближение',
      'кокетливый отступление',
      'кокетливый танец',
      'кокетливый момент',
      'нервный флирт',
      'нервный объятие',
      'нервный шёпот',
      'нервный взгляд',
      'нервный ласка',
      'нервный поцелуй',
      'нервный сближение',
      'нервный отступление',
      'нервный танец',
      'нервный момент',
      'пьяный флирт',
      'пьяный объятие',
      'пьяный шёпот',
      'пьяный взгляд',
      'пьяный ласка',
      'пьяный поцелуй',
      'пьяный сближение',
      'пьяный отступление',
      'пьяный танец',
      'пьяный момент',
      'ревнивый флирт',
      'ревнивый объятие',
      'ревнивый шёпот',
      'ревнивый взгляд',
      'ревнивый ласка',
      'ревнивый поцелуй',
      'ревнивый сближение',
      'ревнивый отступление',
      'ревнивый танец',
      'ревнивый момент',
      'застенчивый флирт',
      'застенчивый объятие',
      'застенчивый шёпот',
      'застенчивый взгляд',
      'застенчивый ласка',
      'застенчивый поцелуй',
      'застенчивый сближение',
      'застенчивый отступление',
      'застенчивый танец',
      'застенчивый момент',
      'смелый флирт',
      'смелый объятие',
      'смелый шёпот',
      'смелый взгляд',
      'смелый ласка',
      'смелый поцелуй',
      'смелый сближение',
      'смелый отступление',
      'смелый танец',
      'смелый момент',
      'напряжённый флирт',
      'напряжённый объятие',
      'напряжённый шёпот',
      'напряжённый взгляд',
      'напряжённый ласка',
      'напряжённый поцелуй',
      'напряжённый сближение',
      'напряжённый отступление',
      'напряжённый танец',
      'напряжённый момент',
      'смущённый флирт',
      'смущённый объятие',
      'смущённый шёпот',
      'смущённый взгляд',
      'смущённый ласка',
      'смущённый поцелуй',
      'смущённый сближение',
      'смущённый отступление',
      'смущённый танец',
      'смущённый момент',
      'тайный флирт',
      'тайный объятие',
      'тайный шёпот',
      'тайный взгляд',
      'тайный ласка',
      'тайный поцелуй',
      'тайный сближение',
      'тайный отступление',
      'тайный танец',
      'тайный момент'
    ]
  }
};

// Get word pack by ID
export const getWordPackById = (id) => {
  return wordPacks[id] || null;
};

// Get random words from pack
export const getRandomWordsFromPack = (packId, count = 5) => {
  const pack = wordPacks[packId];
  if (!pack) return [];

  const shuffled = [...pack.words].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

// Get multiple word packs combined
export const getCombinedWords = (packIds, count = 5) => {
  const allWords = [];

  packIds.forEach(packId => {
    const pack = wordPacks[packId];
    if (pack) {
      allWords.push(...pack.words);
    }
  });

  const shuffled = [...allWords].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

// Check if user has access to word pack
export const hasAccessToWordPack = (pack, userProfile) => {
  if (!pack.isPremium) return true;
  if (userProfile.isPremium) return true;
  if (pack.price && userProfile.purchasedPacks?.includes(pack.id)) return true;
  return false;
};
